import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:5000/api';

// Get stored token
export const getStoredToken = () => {
  try {
    return localStorage.getItem('authToken') || '';
  } catch (_) {
    return '';
  }
};

// Store auth data
export const setStoredAuth = (token, user, remember) => {
  try {
    const cleanToken = token ? token.trim() : '';
    if (remember) {
      localStorage.setItem('authToken', cleanToken);
      localStorage.setItem('authUser', JSON.stringify(user));
    } else {
      sessionStorage.setItem('authToken', cleanToken);
      sessionStorage.setItem('authUser', JSON.stringify(user));
    }
  } catch (_) {
    // ignore storage errors
  }
};

// Clear auth data
export const clearStoredAuth = () => {
  try {
    localStorage.removeItem('authToken');
    localStorage.removeItem('authUser');
    sessionStorage.removeItem('authToken');
    sessionStorage.removeItem('authUser');
  } catch (_) {
    // ignore
  }
};

// Get stored user
export const getStoredUser = () => {
  try {
    const sessionUser = sessionStorage.getItem('authUser');
    const localUser = localStorage.getItem('authUser');
    const raw = sessionUser || localUser;
    return raw ? JSON.parse(raw) : null;
  } catch (_) {
    return null;
  }
};

// Create axios client
const client = axios.create({
  baseURL: API_BASE_URL,
  withCredentials: true,
});

// Interceptor to add Authorization header
client.interceptors.request.use((config) => {
  let token = sessionStorage.getItem('authToken') || localStorage.getItem('authToken') || '';

  // Remove any non-ASCII characters and trim whitespace
  token = token.replace(/[^\x00-\x7F]/g, '').trim();

  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Response interceptor for error handling
client.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    console.error('API Error:', error.config?.url, error.response?.status, error.message);
    return Promise.reject(error);
  }
);

export default client;